import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { InsertOrgContractDocumentEventMutation, InsertOrgContractDocumentEventMutationVariables } from '@/graphql/generated/graphql';
import { InsertOrgContractDocumentEventDocument } from '@/graphql/generated/graphql';
export type OrgContractDocumentEventInsertInput = {
  OrganizationIds?: string[]
  ContractDocumentId?: string
  SigDocumentId?: string
  EventType?: string
  OccurredAt?: string
  SignatoryId?: string
  SignatoryEmail?: string
  SignedTime?: string
  DeclinedBy?: string
  RawPayload?: string
  ActorUserId?: string
  ActorUserName?: string
  ActorUserPhoto?: string
}

export type InsertOrgContractDocumentEventResponse = {
  data: {
    insertOrgContractDocumentEvent: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useInsertOrgContractDocumentEvent = () => {
  const mutation = useMutation({
    mutationKey: ['insert-org-contract-document-event'],
    mutationFn: (variables: OrgContractDocumentEventInsertInput) => {
      return graphqlClient.request<InsertOrgContractDocumentEventMutation>(InsertOrgContractDocumentEventDocument,
        variables
      )
    }
  })

  return {
    ...mutation,
    insertOrgContractDocumentEvent: mutation.mutate,
    insertOrgContractDocumentEventAsync: mutation.mutateAsync,
  }
}

export const INSERT_ORG_CONTRACT_DOCUMENT_EVENT_MUTATION = InsertOrgContractDocumentEventDocument;
